import { BaseService } from "./BaseService";

export class AuxiliaryService extends BaseService {

    constructor(url) {

        super(url);
        
    }

    async getAuxiliaries() {
        return this.get()
    }

}